import Vue from 'vue'
import Router from 'vue-router'
import util from '../common/js/util'
import {Message} from 'element-ui';

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
const home = r => require.ensure([], () => r(require('@/page/home')), 'home');
const userList = r => require.ensure([], () => r(require('@/page/userList')), 'userList');
const userDetail = r => require.ensure([], () => r(require('@/page/userDetail')), 'userDetail');
const sysCodeDictDetail = r => require.ensure([], () => r(require('@/page/configuration/sysCodeDictDetail')), 'sysCodeDictDetail');

//系统管理
const employeeGroupManage = r => require.ensure([], () => r(require('@/page/configuration/employeeGroupManage')), 'employeeGroupManage');
const employeeGroupDetail = r => require.ensure([], () => r(require('@/page/configuration/employeeGroupDetail')), 'employeeGroupDetail');
const employeeManage = r => require.ensure([], () => r(require('@/page/configuration/employeeManage')), 'employeeManage');
const employeeDetail = r => require.ensure([], () => r(require('@/page/configuration/employeeDetail')), 'employeeDetail');
const menuManage = r => require.ensure([], () => r(require('@/page/configuration/menuManage')), 'menuManage');
const menuDetail = r => require.ensure([], () => r(require('@/page/configuration/menuDetail')), 'menuDetail');
const sysCodeDictList = r => require.ensure([], () => r(require('@/page/configuration/sysCodeDictList')), 'sysCodeDictList');
const departmentManage = r => require.ensure([], () => r(require('@/page/configuration/departmentManage')), 'departmentManage');

/**
 * 志愿者管理
 */
const zhiyuanzheList = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/zhiyuanzheList')), 'zhiyuanzheList');
const zhiyuanzheScoreList = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/zhiyuanzheScoreList')), 'zhiyuanzheScoreList');
const zhiyuanzheDetail = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/zhiyuanzheDetail')), 'zhiyuanzheDetail');
const zhiyuanzheListPosition = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/ZhiyuanzheListPosition')), 'zhiyuanzheListPosition');
//志愿者审核
const zhiyuanzheVerify = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/zhiyuanzheVerify')), 'zhiyuanzheVerify');

/**
 * 时长管理
 */
const zhiyuanzheImportList = r => require.ensure([], () => r(require('@/page/zhiyuanzheImport/zhiyuanzheImportList')), 'zhiyuanzheImportList');
const zhiyuanzheImportDetail = r => require.ensure([], () => r(require('@/page/zhiyuanzheImport/zhiyuanzheImportDetail')), 'zhiyuanzheImportDetail');

/**
 * 志愿者导入
 */
const zhiyuanzheListImport = r => require.ensure([], () => r(require('@/page/zhiyuanzhe/ZhiyuanzheListImport')), 'zhiyuanzheListImport');


/**
 * 活动报名
 */
const teamApplyList = r => require.ensure([], () => r(require('@/page/teamApply/teamApplyList')), 'teamApplyList');
const teamApplyDetail = r => require.ensure([], () => r(require('@/page/teamApply/teamApplyDetail')), 'teamApplyDetail');

/**
 * 活动管理
 */
const teamActivityList = r => require.ensure([], () => r(require('@/page/teamActivity/teamActivityList')), 'teamActivityList');
const TeamActivityHistoryList = r => require.ensure([], () => r(require('@/page/teamActivity/TeamActivityHistoryList')), 'TeamActivityHistoryList');
const TeamActivityListAdd = r => require.ensure([], () => r(require('@/page/teamActivity/TeamActivityListAdd')), 'TeamActivityListAdd');
const TeamActivityAuditList = r => require.ensure([], () => r(require('@/page/teamActivity/TeamActivityAuditList')), 'TeamActivityAuditList');
const TeamActivityListWFB = r => require.ensure([], () => r(require('@/page/teamActivity/TeamActivityListWFB')), 'TeamActivityListWFB');
const TeamActivityListYFB = r => require.ensure([], () => r(require('@/page/teamActivity/TeamActivityListYFB')), 'TeamActivityListYFB');
const teamActivityDetail = r => require.ensure([], () => r(require('@/page/teamActivity/teamActivityDetail')), 'teamActivityDetail');
const teamActivityEdit = r => require.ensure([], () => r(require('@/page/teamActivity/teamActivityEdit')), 'teamActivityEdit');

/**
 * 团队管理
 */
const zhiyuanzheTeamList = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamList')), 'zhiyuanzheTeamList');
const zhiyuanzheTeamDetail = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamDetail')), 'zhiyuanzheTeamDetail');
const zhiyuanzheTeamDetailCount = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamDetailCount')), 'zhiyuanzheTeamDetailCount');
const zhiyuanzheTeamVerify = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamVerify')), 'zhiyuanzheTeamVerify');
const zhiyuanzheTeamListVerify = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamListVerify')), 'zhiyuanzheTeamListVerify');
const zhiyuanzheTeamCount = r => require.ensure([], () => r(require('@/page/zhiyuanzheTeam/zhiyuanzheTeamCount')), 'zhiyuanzheTeamCount');

/**
 * 图片广告管理
 */
const sysImgList = r => require.ensure([], () => r(require('@/page/sysImg/sysImgList')), 'sysImgList');
const sysImgDetail = r => require.ensure([], () => r(require('@/page/sysImg/sysImgDetail')), 'sysImgDetail');

/**
 * 城市站管理
 */
const cityManageList = r => require.ensure([], () => r(require('@/page/cityManage/cityManageList')), 'cityManageList');
const cityManageDetail = r => require.ensure([], () => r(require('@/page/cityManage/cityManageDetail')), 'cityManageDetail');

/**
 * 城市站管理员管理
 */
const cityManagePersonList = r => require.ensure([], () => r(require('@/page/cityManagePerson/cityManagePersonList')), 'cityManagePersonList');
const cityManagePersonDetail = r => require.ensure([], () => r(require('@/page/cityManagePerson/cityManagePersonDetail')), 'cityManagePersonDetail');

/**
 * 会员单位管理
 */
const memberTeamList = r => require.ensure([], () => r(require('@/page/memberTeam/memberTeamList')), 'memberTeamList');
const memberTeamDetail = r => require.ensure([], () => r(require('@/page/memberTeam/memberTeamDetail')), 'memberTeamDetail');

/**
 * 辖区管理
 */
const regionList = r => require.ensure([], () => r(require('@/page/region/regionList')), 'regionList');
const regionDetail = r => require.ensure([], () => r(require('@/page/region/regionDetail')), 'regionDetail');

/**
 * Q&A列表
 */
const questionAndAnswerList = r => require.ensure([], () => r(require('@/page/questionAndAnswer/questionAndAnswerList')), 'questionAndAnswerList');
const questionAndAnswerDetail = r => require.ensure([], () => r(require('@/page/questionAndAnswer/questionAndAnswerDetail')), 'questionAndAnswerDetail');


/**
 * 用户反馈列表
 */
const teamFeedbackList = r => require.ensure([], () => r(require('@/page/teamFeedback/teamFeedbackList')), 'teamFeedbackList');
const teamFeedbackDetail = r => require.ensure([], () => r(require('@/page/teamFeedback/teamFeedbackDetail')), 'teamFeedbackDetail');

/**
 * 团队活动留言
 *
*/
const teamActivityMessageList = r => require.ensure([], () => r(require('@/page/teamActivityMessage/teamActivityMessageList')), 'teamActivityMessageList');
const teamActivityMessageDetail = r => require.ensure([], () => r(require('@/page/teamActivityMessage/teamActivityMessageDetail')), 'teamActivityMessageDetail');

/**
 * 团队留言
 */
const teamMessageList = r => require.ensure([], () => r(require('@/page/teamMessage/teamMessageList')), 'teamMessageList');
const teamMessageDetail = r => require.ensure([], () => r(require('@/page/teamMessage/teamMessageDetail')), 'teamMessageDetail');

const router = new Router({
    routes: [
        {
            path: '/',
            component: login,
            meta: {
                titleId: 0
            }
        },
        {
            path: '/manage',
            component: manage,
            name: '',
            children: [{
                path: '',
                component: home,
                meta: {
                    breadcrumb: [],
                }
            }, {
                path: '/userList',
                component: userList,
                meta: {
                    breadcrumb: [
                        {name: '用户管理', url: "/userList"},
                    ],
                }
            }, {
                path: '/userDetail',
                component: userDetail,
                meta: {
                    breadcrumb: [
                        {name: '用户管理', url: "/userList"},
                        {name: '用户编辑', url: "/userDetail"},
                    ],
                }
            }, {
                path: '/employeeGroupManage',
                component: employeeGroupManage,
                meta: {
                    breadcrumb: [
                        {name: '角色列表', url: "/employeeGroupManage"},
                    ],
                }
            }, {
                path: '/employeeGroupDetail',
                component: employeeGroupDetail,
                meta: {
                    breadcrumb: [
                        {name: '角色列表', url: "/employeeGroupManage"},
                        {name: '角色权限编辑', url: "/employeeGroupDetail"},
                    ],
                }
            }, {
                path: '/employeeManage',
                component: employeeManage,
                meta: {
                    breadcrumb: [
                        {name: '用户列表', url: "/employeeManage"},
                    ],
                }
            }, {
                path: '/employeeDetail',
                component: employeeDetail,
                meta: {
                    breadcrumb: [
                        {name: '用户列表', url: "/employeeManage"},
                        {name: '用户编辑', url: "/employeeDetail"},
                    ],
                }
            }, {
                path: '/menuManage',
                component: menuManage,
                meta: {
                    breadcrumb: [
                        {name: '菜单列表', url: "/menuManage"},
                    ],
                }
            }, {
                path: '/menuDetail',
                component: menuDetail,
                meta: {
                    breadcrumb: [
                        {name: '菜单列表', url: "/menuManage"},
                        {name: '菜单编辑', url: "/menuDetail"},
                    ],
                }
            }, {
                path: '/sysCodeDictList',
                component: sysCodeDictList,
                meta: {
                    breadcrumb: [
                        {name: '地区管理', url: "/sysCodeDictList"},
                    ],
                }
            }, {
                path: '/sysCodeDictDetail',
                component: sysCodeDictDetail,
                meta: {
                    breadcrumb: [
                        {name: '类型管理', url: "/sysCodeDictList"},
                        {name: '类型编辑', url: "/sysCodeDictDetail"}
                    ],
                }
            }, {
                path: '/departmentManage',
                component: departmentManage,
                meta: {
                    breadcrumb: [
                        {name: '机构列表', url: "/departmentManage"},
                    ],
                }
            },{
                path: '/zhiyuanzheList',
                component: zhiyuanzheList,
                meta: {
                    breadcrumb: [
                        {name: '志愿者列表', url: "/zhiyuanzheList"},
                    ],
                }
            },
            {
                path: '/zhiyuanzheScoreList',
                component: zhiyuanzheScoreList,
                meta: {
                    breadcrumb: [
                        {name: '积分列表', url: "/zhiyuanzheScoreList"},
                    ],
                }
            },{
                path: '/zhiyuanzheDetail',
                component: zhiyuanzheDetail,
                meta: {
                    breadcrumb: [
                        {name: '志愿者管理', url: "/zhiyuanzheVerify"},
                        {name: '志愿者管理编辑', url: "/zhiyuanzheDetail"},
                    ],
                }
            },{
                path: '/zhiyuanzheListPosition',
                component: zhiyuanzheListPosition,
                meta: {
                    breadcrumb: [
                        {name: '志愿者列表', url: "/zhiyuanzheList"},
                        {name: '志愿者职位', url: "/zhiyuanzheListPosition"},
                    ],
                }
            },{
                path: '/zhiyuanzheVerify',
                component: zhiyuanzheVerify,
                meta: {
                    breadcrumb: [
                        {name: '志愿者管理', url: "/zhiyuanzheVerify"},
                    ],
                }
            },{
                path: '/zhiyuanzheListImport',
                component: zhiyuanzheListImport,
                meta: {
                    breadcrumb: [
                        {name: '志愿者导入', url: "/zhiyuanzheListImport"},
                    ],
                }
            },{
                path: '/zhiyuanzheImportList',
                component: zhiyuanzheImportList,
                meta: {
                    breadcrumb: [
                        {name: '时长导入', url: "/zhiyuanzheImportList"},
                    ],
                }
            },{
                path: '/zhiyuanzheImportDetail',
                component: zhiyuanzheImportDetail,
                meta: {
                    breadcrumb: [
                        {name: '时长导入', url: "/zhiyuanzheImportList"},
                        {name: '时长导入编辑', url: "/zhiyuanzheImportDetail"},
                    ],
                }
            },{
                path: '/teamApplyList',
                component: teamApplyList,
                meta: {
                    breadcrumb: [
                        {name: '活动列表', url: "/teamActivityList"},
                        {name: '活动报名', url: "/teamApplyList"},
                    ],
                }
            },{
                path: '/teamApplyDetail',
                component: teamApplyDetail,
                meta: {
                    breadcrumb: [
                        {name: '活动报名', url: "/teamApplyList"},
                        {name: '活动报名编辑', url: "/teamApplyDetail"},
                    ],
                }
            },{
                path: '/teamActivityList',
                component: teamActivityList,
                meta: {
                    breadcrumb: [
                        {name: '运行中', url: "/teamActivityList"},
                    ],
                }
            },{
                path: '/TeamActivityHistoryList',
                component: TeamActivityHistoryList,
                meta: {
                    breadcrumb: [
                        {name: '已结项', url: "/TeamActivityHistoryList"},
                    ],
                }
            },{
                path: '/TeamActivityListAdd',
                component: TeamActivityListAdd,
                meta: {
                    breadcrumb: [
                        {name: '新增活动', url: "/TeamActivityListAdd"},
                    ],
                }
            },{
                path: '/TeamActivityAuditList',
                component: TeamActivityAuditList,
                meta: {
                    breadcrumb: [
                        {name: '待审核', url: "/TeamActivityAuditList"},
                    ],
                }
            },{
                path: '/TeamActivityListYFB',
                component: TeamActivityListYFB,
                meta: {
                    breadcrumb: [
                        {name: '已发布', url: "/TeamActivityListYFB"},
                    ],
                }
            },{
                path: '/TeamActivityListWFB',
                component: TeamActivityListWFB,
                meta: {
                    breadcrumb: [
                        {name: '未发布', url: "/TeamActivityListWFB"},
                    ],
                }
            },{
                path: '/teamActivityDetail',
                component: teamActivityDetail,
                meta: {
                    breadcrumb: [
                        {name: '活动列表', url: "/teamActivityList"},
                        {name: '活动编辑', url: "/teamActivityDetail"},
                    ],
                }
            },{
                path: '/teamActivityEdit',
                component: teamActivityEdit,
                meta: {
                    breadcrumb: [
                        {name: '活动列表', url: "/teamActivityList"},
                        {name: '活动详情', url: "/teamActivityEdit"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamList',
                component: zhiyuanzheTeamList,
                meta: {
                    breadcrumb: [
                        {name: '我的团队', url: "/zhiyuanzheTeamList"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamDetail',
                component: zhiyuanzheTeamDetail,
                meta: {
                    breadcrumb: [
                        {name: '我的团队', url: "/zhiyuanzheTeamList"},
                        {name: '志愿者团队编辑', url: "/zhiyuanzheTeamDetail"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamDetailCount',
                component: zhiyuanzheTeamDetailCount,
                meta: {
                    breadcrumb: [
                        {name: '团队管理', url: "/zhiyuanzheTeamCount"},
                        {name: '志愿者团队编辑', url: "/zhiyuanzheTeamDetailCount"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamVerify',
                component: zhiyuanzheTeamVerify,
                meta: {
                    breadcrumb: [
                        {name: '志愿者申请', url: "/zhiyuanzheTeamVerify"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamListVerify',
                component: zhiyuanzheTeamListVerify,
                meta: {
                    breadcrumb: [
                        {name: '团队管理', url: "/zhiyuanzheTeamListVerify"},
                    ],
                }
            },{
                path: '/zhiyuanzheTeamCount',
                component: zhiyuanzheTeamCount,
                meta: {
                    breadcrumb: [
                        {name: '团队管理', url: "/zhiyuanzheTeamList"},
                        {name: '团队列表', url: "/zhiyuanzheTeamCount"},
                    ],
                }
            },{
                path: '/sysImgList',
                component: sysImgList,
                meta: {
                    breadcrumb: [
                        {name: '图片广告管理列表', url: "/sysImgList"},
                    ],
                }
            },{
                path: '/sysImgDetail',
                component: sysImgDetail,
                meta: {
                    breadcrumb: [
                        {name: '图片广告管理列表', url: "/sysImgList"},
                        {name: '图片广告管理编辑', url: "/sysImgDetail"},
                    ],
                }
            },{
                path: '/cityManageList',
                component: cityManageList,
                meta: {
                    breadcrumb: [
                        {name: '城市站列表', url: "/cityManageList"},
                    ],
                }
            },{
                path: '/cityManageDetail',
                component: cityManageDetail,
                meta: {
                    breadcrumb: [
                        {name: '城市站列表', url: "/cityManageList"},
                        {name: '城市站编辑', url: "/cityManageDetail"},
                    ],
                }
            },{
                path: '/cityManagePersonList',
                component: cityManagePersonList,
                meta: {
                    breadcrumb: [
                        {name: '城市站管理员列表', url: "/cityManagePersonList"},
                    ],
                }
            },{
                path: '/cityManagePersonDetail',
                component: cityManagePersonDetail,
                meta: {
                    breadcrumb: [
                        {name: '城市站管理员列表', url: "/cityManagePersonList"},
                        {name: '城市站管理员编辑', url: "/cityManagePersonDetail"},
                    ],
                }
            },{
                path: '/memberTeamList',
                component: memberTeamList,
                meta: {
                    breadcrumb: [
                        {name: '会员单位列表', url: "/memberTeamList"},
                    ],
                }
            },{
                path: '/memberTeamDetail',
                component: memberTeamDetail,
                meta: {
                    breadcrumb: [
                        {name: '会员单位列表', url: "/memberTeamList"},
                        {name: '会员单位编辑', url: "/memberTeamDetail"},
                    ],
                }
            },{
                path: '/regionList',
                component: regionList,
                meta: {
                    breadcrumb: [
                        {name: '辖区列表', url: "/regionList"},
                    ],
                }
            },{
                path: '/regionDetail',
                component: regionDetail,
                meta: {
                    breadcrumb: [
                        {name: '辖区列表', url: "/regionList"},
                        {name: '辖区编辑', url: "/regionDetail"},
                    ],
                }
            },{
                path: '/questionAndAnswerList',
                component: questionAndAnswerList,
                meta: {
                    breadcrumb: [
                        {name: 'Q&A列表', url: "/questionAndAnswerList"},
                    ],
                }
            },{
                path: '/questionAndAnswerDetail',
                component: questionAndAnswerDetail,
                meta: {
                    breadcrumb: [
                        {name: 'Q&A列表', url: "/questionAndAnswerList"},
                        {name: 'Q&A编辑', url: "/questionAndAnswerDetail"},
                    ],
                }
            },{
                path: '/teamFeedbackList',
                component: teamFeedbackList,
                meta: {
                    breadcrumb: [
                        {name: '用户反馈中心管理', url: "/teamFeedbackList"},
                        {name: '用户反馈中心列表', url: "/teamFeedbackList"},
                    ],
                }
            },{
                path: '/teamFeedbackDetail',
                component: teamFeedbackDetail,
                meta: {
                    breadcrumb: [
                        {name: '用户反馈中心管理', url: "/teamFeedbackList"},
                        {name: '用户反馈中心列表', url: "/teamFeedbackList"},
                        {name: '用户反馈中心编辑', url: "/teamFeedbackDetail"},
                    ],
                }
            },
            {
                path: '/teamActivityMessageList',
                component: teamActivityMessageList,
                meta: {
                    breadcrumb: [
                        {name: '活动留言', url: "/teamActivityMessageList"},
                    ],
                }
            },{
                path: '/teamActivityMessageDetail',
                component: teamActivityMessageDetail,
                meta: {
                    breadcrumb: [
                        {name: '活动留言', url: "/teamActivityMessageList"},
                        {name: '活动留言编辑', url: "/teamActivityMessageDetail"},
                    ],
                }
            },
            {
                path: '/teamMessageList',
                component: teamMessageList,
                meta: {
                    breadcrumb: [
                        {name: '团队留言', url: "/teamMessageList"},
                    ],
                }
            },{
                path: '/teamMessageDetail',
                component: teamMessageDetail,
                meta: {
                    breadcrumb: [
                        {name: '团队留言', url: "/teamMessageList"},
                        {name: '团队留言编辑', url: "/teamMessageDetail"},
                    ],
                }
            },
            ]
        },
    ]
});


//拦截
router.beforeEach((to, from, next) => {
    let urlList = ['branchList', 'cityList', 'cabinetList', 'cellList'];
    let url = to.path.replace("/", "").trim();
    let index = urlList.indexOf(url)
    if (index > -1) {
        let user = JSON.parse(util.doSessionStorage("get", "user"));
        if (index + 1 >= user.level) {
            next();
        } else {
            Message({
                message: '你没有访问更高一层数据的权限',
                type: 'error'
            });
        }

    } else {
        next();
    }

});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js